/** İlk yanıt beklenirken gösterilen aşama sırası (metinler `patient_ai_analysis.loading_steps.*` çevirilerinden gelir). */
export const PATIENT_AI_ANALYSIS_LOADING_STEP_IDS = [
  "visits_order",
  "scope_visits",
  "daily_care",
  "vitals",
  "general_diseases",
  "diagnoses_epikriz",
  "prescriptions",
  "labs_imaging",
  "pathology_surgery_course",
  "secure_and_ai",
] as const;

export type PatientAiAnalysisLoadingStepId = (typeof PATIENT_AI_ANALYSIS_LOADING_STEP_IDS)[number];

/** Her adım için yaklaşık süre (ms); bekleme sırasında adımlar bu hızda ilerler. */
export const PATIENT_AI_ANALYSIS_STEP_MS = 2200;
